import React from 'react'
import agent from '../../agent'
import { connect } from 'react-redux'
import { TASK_COMPLETE } from '../../constants/actionTypes'

const mapDispatchToProps = dispatch => ({
  onClick: (payload, taskId) =>
    dispatch({ type: TASK_COMPLETE, payload, taskId })
})

const TaskButton = props => {
  const action = () => {
    let payload
    if (props.type && props.type.toLowerCase() === 'reject') {
      payload = agent.Tasks.reject(props.taskId)
    } else {
      payload = agent.Tasks.complete(props.taskId)
    }
    props.onClick(payload, props.taskId)
  }

  return (
    <button className='buttonTask' onClick={action}>
      {props.label}
    </button>
  )
}

export default connect(() => ({}), mapDispatchToProps)(TaskButton)



// WEBPACK FOOTER //
// ./src/components/widgets/TaskButton.js